import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useQuery } from "@tanstack/react-query";

export const useGetRoles = () => {

    const axios = useAxios();
    const {t} = useTranslation();

    const getRoles = async () => {
        try {
            const { data } = await axios.get("/api/role");
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getRoles"));
        }
    }

    return useQuery({queryKey: ["roles"], queryFn: getRoles, staleTime: Infinity})
}